import { Modal, GridItem } from '@sainsburys-tech/luna-react'
import { Body1, Display3 } from '@sainsburys-tech/luna-typography'
import { Button } from '@sainsburys-tech/luna-button'

interface ProductQuantityExceededModalProps {
  open: boolean
  onContinue: () => void
  stockOnHand?: number
  enteredQuantity?: number
}

const ProductQuantityExceededModal = ({ open, onContinue, stockOnHand, enteredQuantity }: ProductQuantityExceededModalProps) => {
  return (
    <Modal small alert hideCloseButton open={open} headingId="dialog-modal">
      <GridItem className="ln-u-text-align-center s-padding-bottom-10">
        <Display3>Quantity exceeds store&apos;s stock on hand!</Display3>
      </GridItem>
      <GridItem className="ln-u-hard ln-u-text-align-left">
        <Body1>
          The quantity of products you entered{enteredQuantity ? ` (${enteredQuantity})` : ''} is greater than the amount of stock in inventory{stockOnHand != null ? ` (stock on hand: ${stockOnHand})` : ''}. If this is correct, please continue. Otherwise please make a change to the products involved.
        </Body1>
      </GridItem>
      <Button
        circle={false}
        disabled={false}
        hard={false}
        element="button"
        variant="filled"
        fullWidth
        className="s-continue-button ln-u-margin-ends*2"
        onClick={onContinue}
      >
        Continue
      </Button>
    </Modal>
  )
}

export default ProductQuantityExceededModal
